var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04524DC1-BEE6-4BFF-927A-C4042DC7989A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.811765 0 0 0 0 0.827451 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "open-folder",
    transform: "translate(-709.000000, -475.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(709.000000, 475.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.19982609,7.39514286 C3.40226087,6.732 4.00382609,6.28571429 4.69565217,6.28571429 L20.3478261,6.28571429 L20.3478261,3.66666667 C20.3478261,3.37752381 20.1146087,3.14285714 19.826087,3.14285714 L10.1921739,3.14285714 L8.26017391,0.233095238 C8.16313043,0.0874761905 8.00034783,0 7.82608696,0 L0.52173913,0 C0.233217391,0 0,0.234666667 0,0.523809524 L0,17.8351905 L3.19982609,7.39514286 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8982609,7.546 C23.7996522,7.41190476 23.6436522,7.33333333 23.4782609,7.33333333 L4.69565217,7.33333333 C4.4666087,7.33333333 4.26417391,7.48314286 4.19686957,7.70314286 L0.0229565217,21.3221905 C-0.0255652174,21.4809048 0.00365217391,21.6537619 0.10173913,21.7873333 C0.199826087,21.9209048 0.356347826,22 0.52173913,22 L19.3043478,22 C19.5333913,22 19.7358261,21.8501905 19.8031304,21.6301905 L23.9770435,8.01114286 C24.0255652,7.85242857 23.9963478,7.67957143 23.8982609,7.546 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFolderIcon);
export default __webpack_public_path__ + "static/media/OpenFolderIcon.ce1d581094869f713918290b43e0b7b4.svg";
export { ForwardRef as ReactComponent };